export default __webpack_public_path__ + "static/media/grafiken_memory_666x666_mit_rand_M3_01.2a64e06d.jpg";